import { render } from "./IosSpanish.vue?vue&type=template&id=7e6850e4&scoped=true"
import script from "./IosSpanish.vue?vue&type=script&lang=js"
export * from "./IosSpanish.vue?vue&type=script&lang=js"

import "./IosSpanish.vue?vue&type=style&index=0&id=7e6850e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e6850e4"]])

export default __exports__